module.exports = __webpack_public_path__ + "FixelDisplay-Thin-c07ff0e0a1a660a0ab28ce99bf2abe21.woff2";